// removed by extract-text-webpack-plugin
module.exports = {"new-input":"_24ohTTR2H vUrsJl1Yt","help-text":"F1Cq5iVpJ _3jNn97stL","field":"_6QK67chwY _6Rx6y_3Rv vUrsJl1Yt","cancel":"_28PQ2N_YR Xua7s1qyX"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/venue-search/venue-search-new-input/venue-search-new-input.css
 ** module id = 2170
 ** module chunks = 0
 **/